import type { DLClickEventProps } from 'tsconfig/types';
import { adobeDataLayer } from './AdobeDataLayer';

export const handleDLClickEvent = (data: string, clickType: string) => {
  //Read the element to get the DL attributes and add to the DL
  const splitContent = data.split(':');
  const lastIndex = splitContent.length - 1;
  const lastText = splitContent[lastIndex];

  function getClickLocation(locationData: string) {
    switch (locationData) {
      case 'recentSearch':
        return 'recent searches';
      case 'popularSearch':
        return 'popular searches';
      case 'suggestedProducts':
        return 'suggested products';
      case 'canWeHelp':
        return 'can we help';
      case 'collections':
        return 'collections';
      case 'recommendSearch':
        return 'recommend search';
      case 'trendingProducts':
        return 'trending products';
      default:
        return 'search box';
    }
  }

  let click: DLClickEventProps = {};
  const TOP_NAVIGATION_CLICK = 'top navigation click';
  const FOOTER_NAV_CLICK_LOCATION = 'footer nav';
  const SUBSCRIBE_AND_SAVE_NAME = 'Open Subscribe and Save Overlay';
  const SHOW_SUBSCRIBE_AND_SAVE = 'Show Subscribe and Save';
  const SUBSCRIBE_AND_SAVE_LOCATION = 'Cart';

  const mainNavClick: DLClickEventProps = {
    clickDescription: `top nav: ${data}`,
    clickName: 'main navigation click',
    clickLocation: 'main nav',
    clickText: lastText,
    clickAction: 'navigation',
  };
  const topNavClick: DLClickEventProps = {
    clickDescription: `top nav: ${data} logo`,
    clickName: TOP_NAVIGATION_CLICK,
    clickLocation: 'top nav',
    clickText: data,
    clickAction: 'navigation',
  };
  const cartIcon: DLClickEventProps = {
    clickDescription: 'top nav:cart',
    clickName: TOP_NAVIGATION_CLICK,
    clickLocation: 'top nav',
    clickText: data,
    clickAction: 'shopping cart icon',
  };
  const search: DLClickEventProps = {
    clickDescription: 'top nav: search',
    clickName: TOP_NAVIGATION_CLICK,
    clickLocation: getClickLocation(data),
    clickText: 'search',
    clickAction: 'search overlay',
  };
  const loginButton: DLClickEventProps = {
    clickDescription: 'top nav:login',
    clickName: TOP_NAVIGATION_CLICK,
    clickLocation: 'top nav',
    clickText: data,
    clickAction: 'login overlay',
  };
  const notYou: DLClickEventProps = {
    clickDescription: 'top nav:not you',
    clickName: TOP_NAVIGATION_CLICK,
    clickLocation: 'top nav',
    clickText: data,
    clickAction: 'hard log out',
  };
  const logout: DLClickEventProps = {
    clickDescription: `top nav: ${data}`,
    clickName: TOP_NAVIGATION_CLICK,
    clickLocation: 'top nav',
    clickText: data,
    clickAction: 'log out',
  };
  const print: DLClickEventProps = {
    clickDescription: 'product:print wine label',
    clickName: 'print',
    clickLocation: 'product',
    clickText: 'print',
    clickAction: 'beyond label overlay',
  };
  const favourite: DLClickEventProps = {
    clickDescription: 'product:favourite',
    clickName: 'favourite',
    clickLocation: 'product favourite',
    clickText: 'favourite wine',
    clickAction: 'favourite',
    errorMessage: '',
  };
  const unfavourite: DLClickEventProps = {
    clickDescription: 'product:unfavourite',
    clickName: 'unfavourite',
    clickLocation: 'product unfavourite',
    clickText: 'unfavourite wine',
    clickAction: 'unfavourite',
    errorMessage: '',
  };
  const phoneClick: DLClickEventProps = {
    clickDescription: `footer nav:tel:${data}`,
    clickName: 'phone link',
    clickLocation: FOOTER_NAV_CLICK_LOCATION,
    clickText: data,
    clickAction: 'phone',
  };
  const liveChatInteraction: DLClickEventProps = {
    clickDescription: 'footer nav:live chat:open',
    clickName: 'live chat',
    clickLocation: FOOTER_NAV_CLICK_LOCATION,
    clickText: 'Live Chat',
    clickAction: 'open',
  };
  const emailClick: DLClickEventProps = {
    clickDescription: 'footer nav:email',
    clickName: 'email link',
    clickLocation: FOOTER_NAV_CLICK_LOCATION,
    clickText: 'Email',
    clickAction: 'email',
  };
  const accordionMenu: DLClickEventProps = {
    clickDescription: `footer nav:${lastText}`,
    clickName: FOOTER_NAV_CLICK_LOCATION,
    clickLocation: FOOTER_NAV_CLICK_LOCATION,
    clickText: lastText,
    clickAction: splitContent[0],
  };
  const socialShare: DLClickEventProps = {
    clickDescription: `footer nav:social share:${data}`,
    clickName: 'social share',
    clickLocation: FOOTER_NAV_CLICK_LOCATION,
    clickText: data,
    clickAction: 'social share',
  };
  const SubscribeSaveCart: DLClickEventProps =
    data === SHOW_SUBSCRIBE_AND_SAVE
      ? {
          clickDescription: `${SUBSCRIBE_AND_SAVE_LOCATION}:${SHOW_SUBSCRIBE_AND_SAVE}`,
          clickName: SHOW_SUBSCRIBE_AND_SAVE,
          clickLocation: SUBSCRIBE_AND_SAVE_LOCATION,
          clickText: SHOW_SUBSCRIBE_AND_SAVE,
          clickAction: SHOW_SUBSCRIBE_AND_SAVE,
        }
      : {
          clickDescription: `${SUBSCRIBE_AND_SAVE_LOCATION}:${SUBSCRIBE_AND_SAVE_NAME}`,
          clickName: SUBSCRIBE_AND_SAVE_NAME,
          clickLocation: SUBSCRIBE_AND_SAVE_LOCATION,
          clickText: data,
          clickAction: SUBSCRIBE_AND_SAVE_NAME,
        };
  const SubscribeSaveProduct: DLClickEventProps = {
    clickDescription: `Product:${SUBSCRIBE_AND_SAVE_NAME}`,
    clickName: SUBSCRIBE_AND_SAVE_NAME,
    clickLocation: 'Product',
    clickText: 'How does it work?',
    clickAction: SUBSCRIBE_AND_SAVE_NAME,
  };

  switch (clickType) {
    case 'mainNavClick':
      click = mainNavClick;
      break;
    case 'topNavClick':
      click = topNavClick;
      break;
    case 'cartIcon':
      click = cartIcon;
      break;
    case 'search':
      click = search;
      break;
    case 'loginButton':
      click = loginButton;
      break;
    case 'notYou':
      click = notYou;
      break;
    case 'logout':
      click = logout;
      break;
    case 'print':
      click = print;
      break;
    case 'favourite':
      click = favourite;
      break;
    case 'unfavourite':
      click = unfavourite;
      break;
    case 'phoneClick':
      click = phoneClick;
      break;
    case 'liveChatInteraction':
      click = liveChatInteraction;
      break;
    case 'emailClick':
      click = emailClick;
      break;
    case 'accordionMenu':
      click = accordionMenu;
      break;
    case 'socialShare':
      click = socialShare;
      break;
    case 'SubscribeSaveCart':
      click = SubscribeSaveCart;
      break;
    case 'SubscribeSaveProduct':
      click = SubscribeSaveProduct;
      break;
    default:
      return;
  }
  adobeDataLayer.clickEvent(clickType, click);
};
